import classNames from 'classnames'

const PanelBody = ({ children, collapsible, isOpen, customClass = '' }) => (
  <div class={classNames({
    'panel-body': true,
    'panel-body--collapsible': collapsible,
    'panel-body--collapse': !isOpen },
  customClass
  )}>
    {children}
  </div>
)

export default PanelBody
